import React, { useEffect, useRef } from 'react'

export default function TypeOptions({
    fullOrRemaining,
    isPartialByItemAvailable=true,
    previousRefundTypes=[],
    refundOption,
    setRefundOption=() => {},
}) {

    const options = useRef(null)

    const handleRefundOptionChange = (e) => {
        setRefundOption(e.target.value)
    }

    // Auto-select the first option if no previous refund types are present
    // and the refund option does not match the default first option.
    //
    // This is a backup in case the radio button is not selected by default
    // when the state is initially set in the RefundForm parent component.
    useEffect(() => {
        if (options.current && !!previousRefundTypes && previousRefundTypes.length > 0) {
            options.current.querySelectorAll('label')?.[0]?.click()
        }
    }, [])

    return (
        <div className='mt-5 pt-2 mb-2'>

            <div className='form-group pb-0'>
                <label className='d-block w-100'>Type of Refund:</label>
            </div>

            <div ref={options}>
                {
                   !['custom_pre_payment', 'custom_payment', 'partial_by_item'].some(e => previousRefundTypes.includes(e)) && <>
                        <input
                            type='radio'
                            name='full'
                            id='full'
                            value='full'
                            checked={refundOption === 'full'}
                            className='radio-tab-input mr-1 ml-3'
                            onChange={handleRefundOptionChange}
                        />
                        <label
                            htmlFor='full'
                            className='cursor-pointer text-capitalize pl-1'
                            children={`${fullOrRemaining} Amount`}
                        />
                    </>
                }

                {
                    !['custom_pre_payment', 'partial_by_item', 'full'].some(e => previousRefundTypes.includes(e)) && <>
                        <input
                            type='radio'
                            name='custom_payment'
                            id='custom_payment'
                            value='custom_payment'
                            checked={refundOption === 'custom_payment'}
                            className='radio-tab-input mr-1 ml-3'
                            onChange={handleRefundOptionChange}
                        />
                        <label
                            htmlFor='custom_payment'
                            className='cursor-pointer pl-1'
                            children='Custom Amount'
                        />
                    </>
                }

                {
                    isPartialByItemAvailable &&
                    !['custom_pre_payment', 'custom_payment', 'full'].some(e => previousRefundTypes.includes(e)) && <>
                        <input
                            type='radio'
                            name='partial_by_item'
                            id='partial_by_item'
                            value='partial_by_item'
                            checked={refundOption === 'partial_by_item'}
                            className='radio-tab-input mr-1 ml-3'
                            onChange={handleRefundOptionChange}
                        />
                        <label
                           htmlFor='partial_by_item'
                           className='cursor-pointer pl-1'
                           children='Specific Item(s)'
                       />
                    </>
                }
            </div>
        </div>
    )
}
